import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { Dropdown } from 'primereact/dropdown';

import FlagBr from './../../images/Flags/br.png';
import FlagCl from './../../images/Flags/cl.png';
import FlagUs from './../../images/Flags/us.png';
import './LanguageDropdown.css';

class LanguageDropdownBase extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentLanguage: this.getInitialLanguage()
        };

        this.handleExternalLanguageChange = this.handleExternalLanguageChange.bind(this);
    }

    componentDidMount() {
        if (this.props.i18n && this.props.i18n.on) {
            this.props.i18n.on('languageChanged', this.handleExternalLanguageChange);
        }
    }

    componentWillUnmount() {
        if (this.props.i18n && this.props.i18n.off) {
            this.props.i18n.off('languageChanged', this.handleExternalLanguageChange);
        }
    }

    getInitialLanguage() {
        if (typeof localStorage === 'undefined') return this.props.i18n?.language || 'pt-BR';

        return localStorage.getItem('appLang') || this.props.i18n?.language || 'pt-BR';
    }

    getLanguageOptions() {
        return [
            { label: 'Português', value: 'pt-BR', code: 'PT', flag: FlagBr },
            { label: 'English', value: 'en-US', code: 'EN', flag: FlagUs },
            { label: 'Español', value: 'es-CL', code: 'ES', flag: FlagCl }
        ];
    }

    handleLanguageChange(event) {
        const language = event.value;

        localStorage.setItem('appLang', language);

        if (this.props.i18n) {
            this.props.i18n.changeLanguage(language);
        }

        this.setState({ currentLanguage: language });
    }

    handleExternalLanguageChange(language) {
        this.setState({ currentLanguage: language });
    }

    renderLanguageTemplate(option) {
        if (!option) return null;

        return (
            <div className="language-dropdown__option">
                <img src={option.flag} alt={option.label} className="language-dropdown__flag" />
                <span>{option.label}</span>
            </div>
        );
    }

    renderSelectedLanguageTemplate(option) {
        if (!option) return null;

        return (
            <div className="language-dropdown__selected">
                <img src={option.flag} alt={option.label} className="language-dropdown__flag" />
                <span className="language-dropdown__selected-code">{option.code}</span>
            </div>
        );
    }

    render() {
        return (
            <div className={this.props.className}>
                <Dropdown
                    className="language-dropdown"
                    panelClassName="language-dropdown__panel"
                    value={this.state.currentLanguage}
                    options={this.getLanguageOptions()}
                    onChange={this.handleLanguageChange.bind(this)}
                    itemTemplate={this.renderLanguageTemplate.bind(this)}
                    valueTemplate={this.renderSelectedLanguageTemplate.bind(this)}
                />
            </div>
        );
    }
}

LanguageDropdownBase.defaultProps = {
    className: ''
};

LanguageDropdownBase.propTypes = {
    className: PropTypes.string
};

export const LanguageDropdown = withNamespaces()(LanguageDropdownBase);
